const toBookItem = (item) => ({
    sku: item.sku,
    isbnean: item.isbnean,
    name: item.name,
    image: item.image,
    shapeIdentifier: item.shapeIdentifier,
    canBeVisible: true,
});
const dedupeBySku = (items) => {
    return items.filter((item, index, list) => list.findIndex((candidate) => candidate.sku === item.sku) === index);
};
const getGiftItems = (giftConfig, selectedGiftSkus) => {
    const sectionItems = giftConfig.sections?.flatMap((section) => section.items) ?? [];
    const availableGiftItems = dedupeBySku((sectionItems.length > 0 ? sectionItems : giftConfig.items).filter((item) => Boolean(item.sku)));
    if (availableGiftItems.length === 0) {
        return [];
    }
    const selectedSkus = new Set((selectedGiftSkus ?? []).filter(Boolean));
    if (selectedSkus.size === 0) {
        return availableGiftItems.map(toBookItem);
    }
    const selectedGiftItems = availableGiftItems.filter((item) => selectedSkus.has(item.sku));
    return selectedGiftItems.map(toBookItem);
};
export const getBookClubDisplayProducts = ({ isBookClub, shouldDisplayGifts, selectedGiftSkus, giftConfig, dispatchProducts, }) => {
    if (!isBookClub) {
        return dispatchProducts;
    }
    if (shouldDisplayGifts) {
        return getGiftItems(giftConfig, selectedGiftSkus);
    }
    return dispatchProducts;
};
